import React from 'react';

import CustomLincExportBookingsForm from '../Common/Forms/CustomLincExportBookingsForm';
import CustomLincExportPayableForm from '../Common/Forms/CustomLincExportPayableForm';

import ContentWithSidebar from './ContentWithSidebar';

const DEFAULT_ITEM = 'customlinc-bookings';

export const items = [
  {
    title: 'CustomLinc Bookings',
    slug: 'customlinc-bookings',
    component: CustomLincExportBookingsForm,
  },
  {
    title: 'CustomLinc Payable Report',
    slug: 'customlinc-payable',
    component: CustomLincExportPayableForm,
  },
];

export default function CustomLincPage() {
  return <ContentWithSidebar items={items} defaultItem={DEFAULT_ITEM} />;
}
